module.exports = __webpack_public_path__ + "static/media/recepcionista.1a12ff5d.svg";